// Costanti di dominio, etichette in italiano, colori di stato.
export const ROLES = {
  amministratore: "Amministratore",
  responsabile_logistica: "Responsabile Logistica",
  pm_produzione: "Project Manager / Produzione",
  autista: "Autista",
};

export const OPERATION_TYPES = {
  ritiro: "Ritiro",
  consegna: "Consegna",
  trasferimento: "Trasferimento tra sedi",
};

export const PRIORITIES = {
  ordinaria: "Ordinaria",
  alta: "Alta",
  urgente: "Urgente",
};

export const AZIENDE = ["Ludovica Mascheroni", "Rimalcuoio"];

export const PRIORITY_STYLE = {
  ordinaria: "bg-[#F4EFEA] text-[#5A493C] border-[#D5C5B5]",
  alta: "bg-[#FEF8EC] text-[#9A6B00] border-[#F3D295]",
  urgente: "bg-[#FDF2F2] text-[#991B1B] border-[#F8B4B4]",
};

export const VEHICLE_CATEGORIES = ["Macchina", "Furgoncino", "Furgone", "Furgone Cassonato"];

export const NEEDS = {
  fragile: "Merce fragile",
  protezione_pioggia: "Protezione pioggia",
  coperto: "Da tenere al coperto",
  sponda_idraulica: "Sponda idraulica",
  muletto: "Muletto",
  seconda_persona: "Seconda persona",
  altro: "Altro",
};

export const REQUEST_STATUS = {
  da_pianificare: "Da pianificare",
  pianificata: "Pianificata",
  pubblicata: "Pubblicata",
  in_corso: "In corso",
  completata: "Completata",
  parziale: "Parziale",
  non_effettuata: "Non effettuata",
  annullata: "Annullata",
};

export const EXEC_STATUS = {
  da_effettuare: "Da effettuare",
  in_corso: "In corso",
  completata: "Completata",
  parziale: "Parziale",
  non_effettuata: "Non effettuata",
};

export const STATUS_STYLE = {
  da_pianificare: "bg-[#F4EFEA] text-[#5A493C] border-[#D5C5B5]",
  da_effettuare: "bg-[#F4EFEA] text-[#5A493C] border-[#D5C5B5]",
  pianificata: "bg-[#EFE9F6] text-[#5B3E86] border-[#CDBCE6]",
  pubblicata: "bg-[#EBF3FA] text-[#1D4ED8] border-[#96C2EC]",
  in_corso: "bg-[#EBF3FA] text-[#1D4ED8] border-[#96C2EC]",
  completata: "bg-[#EFF7F2] text-[#166534] border-[#9AD4AC]",
  parziale: "bg-[#FEF8EC] text-[#9A6B00] border-[#F3D295]",
  non_effettuata: "bg-[#FDF2F2] text-[#991B1B] border-[#F8B4B4]",
  annullata: "bg-[#F1F0EF] text-[#71717A] border-[#D4D4D8]",
  bozza: "bg-[#F4EFEA] text-[#5A493C] border-[#D5C5B5]",
  pubblicato: "bg-[#EBF3FA] text-[#1D4ED8] border-[#96C2EC]",
  completato: "bg-[#EFF7F2] text-[#166534] border-[#9AD4AC]",
};

export const MISSING_LABELS = {
  origin_address: "Indirizzo di partenza",
  dest_address: "Indirizzo di destinazione",
  deadline: "Scadenza operazione",
  goods_description: "Descrizione merce",
  vehicle_required: "Mezzo richiesto",
};

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" }); }
  catch { return iso; }
}

export function todayStr() {
  return new Date().toISOString().slice(0, 10);
}

export function tourDeparture(t) {
  return t?.start_time || t?.driver?.work_start || "08:00";
}
